const state = {
    role: ''
};
const mutations = {
    'm:user/role' (state, role) {
        state.role = role;
    }
};
const actions = {};
export default {
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/user/index.js